/*
 * 機能別コンポーネント 工事一覧パネル画面で使用するconst・interface・types
 *   更新履歴
 *   2021/02/05 ファイル作成 富本
 */

// 一覧内のチップ背景色情報 (色、カラム名)
export const chipItems = [
  { color: 'primary', name: 'status'}
];
